module.exports = __webpack_public_path__ + "static/media/Myanmar - MM.2bc87ded.png";